(() => {
  const root = document.querySelector('[data-collection-lighting]');
  const toggle = root?.querySelector('[data-collection-light-switch]');
  if (!toggle) return;
  const label = toggle.querySelector('[data-collection-light-label]');
  const status = root.querySelector('[data-collection-light-status]');
  const pending = new WeakMap();
  let lightsOn = true;
  function loadImage(img) {
    if (!pending.has(img)) {
      img.src = img.dataset.collectionOff;
      pending.set(img, img.decode().catch(error => { pending.delete(img); throw error; }));
    }
    return pending.get(img);
  }
  function prepareImages() {
    return Promise.all(Array.from(root.querySelectorAll('[data-collection-off]'), loadImage));
  }
  function showState() {
    root.dataset.lights = lightsOn ? 'on' : 'off';
    toggle.setAttribute('aria-checked', String(lightsOn));
    label.textContent = lightsOn ? 'Lights on' : 'Lights off';
  }
  showState();
  toggle.hidden = false;
  toggle.addEventListener('pointerenter', () => prepareImages().catch(() => {}));
  toggle.addEventListener('focus', () => prepareImages().catch(() => {}));
  toggle.addEventListener('click', async () => {
    toggle.disabled = true;
    status.textContent = '';
    try {
      if (lightsOn) {
        label.textContent = 'Switching off…';
        await prepareImages();
      }
      lightsOn = !lightsOn;
    } catch {
      status.textContent = 'The lighting preview could not load. Please try again.';
    } finally {
      showState();
      toggle.disabled = false;
    }
  });
  // Filters and sorting replace the grid without reloading the section.
  const grid = root.querySelector('#ProductGridContainer');
  if (grid) new MutationObserver(() => {
    if (!lightsOn) prepareImages().catch(() => {
      lightsOn = true;
      showState();
      status.textContent = 'The lighting preview could not load. Please try again.';
    });
  }).observe(grid, { childList: true, subtree: true });
  // A new page visit, including browser Back, starts with lights on.
  window.addEventListener('pageshow', event => {
    if (event.persisted) { lightsOn = true; showState(); }
  });
})();
